export class PayNowUser {
    personId: number;
    fullName: string;
    firstName: string;
    middleName: string;
    lastName:string;
    line1: string;
    city: string;
    stateProvince: string;
    zip: string;
    countryId: string;    
    email: string;
    dataDescriptor = null;
    dataValue = null;

}